import React, { useState } from 'react'
import './style.scss'
// import { Icon } from 'react-icons-kit'
// import { check } from 'react-icons-kit/feather'
import { Images } from '../../../utils/Images'
// import PurchaseModal from './Purchase'
import Request from '../../../utils/Requests/Index'
import { ToastContainer, toast } from 'react-toastify'


const Index = (props) => {

    const [loading, setLoading] = useState(false)
    const [header] = useState({ headers: { Authorization: "Bearer " + localStorage.getItem('token') } })
    const { title, currency, finalCurrency, currencyType, type, durationType, duration, proposal = {}, discountPercentage } = props.data
    const hasDiscount = Number(discountPercentage) > 0
    const billingPeriod = `${duration} ${durationType === 'Day' ? 'day' : 'month'}${Number(duration) === 1 ? '' : 's'}`
// image,
    const surjoRequest = async (data) => {
        setLoading(true)
        try {
            const res = await Request.Package.SurjoRequest(data, header)
            if (res.link) {
                window.location.replace(`${res.link}`)
                return
            }

            toast.error(res.message || 'Unable to start your purchase. Please try again.', {
                autoClose: 4000
            })
        } catch (error) {
            toast.error('Unable to start your purchase. Please try again.', {
                autoClose: 4000
            })
        } finally {
            setLoading(false)
        }
    }

    return (
        <article className={`card package-card border-0 ${hasDiscount ? 'package-card--discounted' : ''}`}>
            <ToastContainer position="top-right" autoClose={3000} />
            <div className="package-card__header">
                <span className="package-card__eyebrow">{type || 'Membership plan'}</span>
                <h2 className="package-card__title">{title}</h2>
                {hasDiscount && <span className="package-card__discount">Save {discountPercentage}%</span>}
            </div>

            <div className="card-body package-card__body">
                <div className="package-card__price" aria-label={`Price ${hasDiscount ? finalCurrency : currency} ${currencyType}`}>
                    {hasDiscount && <span className="package-card__old-price">{currency} {currencyType}</span>}
                    <span className="package-card__amount">{hasDiscount ? finalCurrency : currency}</span>
                    <span className="package-card__currency">{currencyType}</span>
                </div>
                <p className="package-card__duration">Valid for {billingPeriod}</p>

                <div className="package-card__divider" />
                <p className="package-card__included">What's included</p>
                <ul className="package-card__features">
                    <li><img src={Images.checkIcon} alt="" />Send proposals to {proposal.totalLimit} people</li>
                    <li><img src={Images.checkIcon} alt="" />View {proposal.contactViewLimit} contact details</li>
                    <li><img src={Images.checkIcon} alt="" />Unlimited messaging</li>
                </ul>
            </div>
            <footer className="card-footer package-card__footer">
                <button type="button" className="btn package-card__button" style={{
      background: '#1E403A',
      color: '#fff',
    }} onClick={() => surjoRequest(props.data)} disabled={loading}>
                    {loading ? 'Requesting...' : 'Choose plan'}
                </button>
            </footer>
        </article>
    );
};

export default Index;
